let isListenerAdded = false;
function addScrollClickListener() {
  if (isListenerAdded) return;

  const reviewLink = document.querySelector('.yotpo-display-wrapper .standalone-bottomline .text-m[tabindex="-1"]');
  const targetDiv = document.getElementById('yotpo-reviews-main-widget');

  if (reviewLink && targetDiv) {
    reviewLink.addEventListener('click', function (event) {
      targetDiv.scrollIntoView({ behavior: 'smooth' });
    });
    isListenerAdded = true;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        addScrollClickListener();
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
